import { defineMessages } from 'react-intl';

export default defineMessages({
    twitter: {
        id: 'Social.editDialog.twitter.placeholder',
        defaultMessage: 'Your Twitter handle, example : welovedevs'
    },
    linkedin: {
        id: 'Social.editDialog.linkedin.placeholder',
        defaultMessage:
            'Your Linkedin profile url, example : https://www.linkedin.com/in/%F0%9F%A5%B3-cl%C3%A9ment-devos-4b832526/'
    },
    codinggame: {
        id: 'Social.editDialog.codingame.placeholder',
        defaultMessage: 'Your Codingame profile id, example : ed3ee82f9630e99db32dec093b2ca07a0368002'
    },
    github: {
        id: 'Social.editDialog.github.placeholder',
        defaultMessage: 'Your Github profile, example : clementdevos'
    },
    custom: {
        id: 'Social.editDialog.custom.placeholder',
        defaultMessage: 'Your custom network, example:  Portfolio'
    },
    customUrl: {
        id: 'Social.editDialog.custom.url.placeholder',
        defaultMessage: 'Your custom URL, example:  https://myporfolio.awesome.rocket.fr'
    }
});
